import { PageLayout } from "../../components/page-layout";
import useArchiveStats from "./useArchiveStats";
import StatCard from "../../components/stat-card/StatCard";
import StatNumberCard from "../../components/stat-number-card/StatNumberCard";
import { StandaloneDateRangeFilter } from "../../components/filters/DateRangeFilter/StandaloneDateRangeFilter";
import { Button } from "../../components/button";
import { Icon } from "../../modules/icon";

const ArchiveStatsScreen = () => {
  const {
    total,
    residential,
    business,
    loading,
    onChangeDateRange,
    defaultDateRange,
    exportAStats,
  } = useArchiveStats();
  return (
    <PageLayout
      loading={loading}
      title={"Archive Dashboard"}
      titleRight={
        <div className="text-right">
          <Button className="btn btn-success" onClick={exportAStats}>
            <Icon type="fa-solid fa-file-export" />
            &nbsp; Export
          </Button>
        </div>
      }
    >
      <div className="flex-column gap-3">
        <div className="flex-row no-wrap gap-2 flex-1" style={{ alignItems: "end" }}>
          <StandaloneDateRangeFilter
            onSet={(value) => {
              onChangeDateRange(value);
            }}
            defaultVal={defaultDateRange}
          />
        </div>
        <StatNumberCard title={"Archived Documents"} total={total} />
        <div className="flex-row gap-2 flex-wrap">
          {business && <StatCard {...business} />}
          {residential && <StatCard {...residential} />}
        </div>
      </div>
    </PageLayout>
  );
};
export default ArchiveStatsScreen;
